<template>
  <div class="sendlist" :class="sendlist.length > 3 ? '' : 'ht'" id="">
    <DtolList :orderId="orderId" :text="text" @priceList="priceList"></DtolList>
  </div>
</template>

<script>
import DtolList from "../common/DtList";
export default {
  // props:['priceList'],
  created() {
    this.orderId = this.$route.query.orderId
    this.text = this.$route.query.text
  },
  data() {
    return{
      orderId:'',
      text:'',
      sendlist:[]
    }
  },
  methods: {
    priceList() {
      // this.sendlist = list
      document.getElementById

    }
  },
  components: { DtolList }
};
</script>

<style scoped>
.sendlist {
  /* height: 100%; */
  background: rgba(242, 242, 242, 1);
}
.ht{
  height: 100%;
}
</style>